import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CredenciaisService } from '../../services/credenciais.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-cadastro-credencial',
  templateUrl: './modal-cadastro-credencial.component.html',
  styleUrls: ['./modal-cadastro-credencial.component.scss'],
})
export class ModalCadastroCredencialComponent implements OnInit {
  @Input() corPrimaria: string;
  @Input() corSecundaria: string;
  @Input() ambiente: any;
  @Input() solicitacao: any;
  @Output() fecharModal = new EventEmitter();

  noUsuario: string;
  senha: string;
  senhaConfirmacao: string;
  typeText: boolean;

  constructor(
    private credenciaisService: CredenciaisService,
    private toastService: ToastrService,
    private loading: NgxSpinnerService
  ) {}

  ngOnInit() {
    if (this.solicitacao.credencial.stCredencial === 'ATIVA') {
      this.noUsuario = this.solicitacao.credencial.noUsuario;
    }
  }

  fechar(update: boolean) {
    this.fecharModal.emit(update);
  }

  async concluir() {

    //VALIDACAO PORTFOLIO 9(BNAFAR)
    if(this.solicitacao.portfolioSolicitado.idPortfolio == 9){
      if (!this.noUsuario || !this.noUsuario.trim()) {
      this.toastService.error('O campo usuário é obrigatório');
      return;
    }
    if (!this.senha || !this.senha.trim()) {
      this.toastService.error('O campo senha é obrigatório');
      return;
    }
    if (this.noUsuario.length < 6 || this.noUsuario.length > 8) {
      this.toastService.error('O nome de usuário deve conter entre 6 e 8 caracteres.');
      return;
    }
    

    if (this.senha.length < 8) {
      this.toastService.error('O campo senha deve conter no mínimo 8 caracteres');
      return;
    }

    if (!this.senhaConfirmacao || !this.senhaConfirmacao.trim()) {
      this.toastService.error('É necessário confirmar a senha');
      return;
    }
    if (this.senhaConfirmacao.trim() !== this.senha.trim()) {
      this.toastService.error('Senhas diferentes');
      return;
    }
    }//VALIDACAO OUTROS PORTFOLIOS
    else{
      if (!this.noUsuario || !this.noUsuario.trim()) {
      this.toastService.error('O campo usuário é obrigatório');
      return;
    }
    if (!this.senha || !this.senha.trim()) {
      this.toastService.error('O campo senha é obrigatório');
      return;
    }
    if (this.noUsuario.length < 5) {
      this.toastService.error('O campo usuário deve conter no mínimo 5 caracteres');
      return;
    }
    if (this.senha.length < 8) {
      this.toastService.error('O campo senha deve conter no mínimo 8 caracteres');
      return;
    }

    if (!this.senhaConfirmacao || !this.senhaConfirmacao.trim()) {
      this.toastService.error('É necessário confirmar a senha');
      return;
    }
    if (this.senhaConfirmacao.trim() !== this.senha.trim()) {
      this.toastService.error('Senhas diferentes');
      return;
    }
    }


    

    try {
  this.loading.show();
  let response;

  if (this.ambiente === 'HMG') {
    response = await this.credenciaisService.gerarCredencialHmg({
      dsSenhaHomologacao: this.senha,
      idSolicitacao: this.solicitacao.solicitacao.idSolicitacao,
      noUsuario: this.noUsuario
    }).toPromise();
  } else if (this.ambiente === 'PROD') {
    response = await this.credenciaisService.gerarCredencialProd({
      dsSenhaProducao: this.senha,
      idSolicitacao: this.solicitacao.solicitacao.idSolicitacao,
      noUsuario: this.noUsuario
    }).toPromise();
  }

  this.loading.hide();

  if (response && response.sucesso) {
    this.toastService.success(this.solicitacao.credencial.stCredencial === 'ATIVA'
      ? 'Credencial alterada com sucesso' : 'Credencial cadastrada com sucesso');
    this.fechar(true);
  } else {
    let mensagem = response.mensagem;

    if (mensagem && mensagem.includes('Nome de usuario em utilizacao')) {
      mensagem = 'Nome de usuário já existente. Por favor, informe um nome diferente.';
    }

    this.toastService.error(mensagem || 'Erro ao cadastrar credencial');
    
  }

} catch (e) {
  this.loading.hide();
  this.toastService.error('Erro ao cadastrar credencial');
}
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-cadastro-credencial/modal-cadastro-credencial.component.ts